import React from "react";
import UsergroupIcon from "../../../assets/icons/user_group.svg2";
import { useGetActiveUsersWidgetDataQuery } from "../../store/slices/widgetsSlice";
import HelpButton from "../../HelpContent/HelpButton";

export default function LiveEventsWidget() {
  // const [data, setdata] = useState({ registeredUsers: 12.455, difference: 28 ,thisWeek:1});
  const { data = { today: 0, yesterday: 0, previousWeek: 0, thisWeek: 0 } } =
    useGetActiveUsersWidgetDataQuery();
  const difference = data.today - data.yesterday;

  return (
    <div className=" h-100 text-white rounded-3 p-3">
      <div className="">
        <UsergroupIcon width={20} className="me-2 white opacity-50" />
        <span className="small fw-bold widget-header">LIVE EVENTS </span>
        <HelpButton helpKey="widget-active-users" iconClassName="white" />
      </div>
      <hr className="text-white my-2" />
      <div className="text-center my-2">
        <h1 className="fw-bold display-5 m-0">{data.today}</h1>
        <h6 className="opacity-75 fw-bold">TOTAL EVENT</h6>
        {/* {difference > 0 && (
          <div className="text-green fw-bold">
            <span className="fs-4 align-top">&#9650; &#43;</span>
            <span className="fs-3">{difference}</span>
            <div className="fs-6 fw-bold text-white">vs previous day</div>
          </div>
        )}
        {difference < 0 && (
          <div className="text-red fw-bold">
            <span className="fs-4 align-top">&#9660; &minus;</span>
            <span className="fs-3">{Math.abs(difference)}</span>
            <div className="fs-6 fw-bold text-white">vs previous day</div>
          </div>
        )} */}
        {difference === 0 && (
          <div className="text-red fw-bold">
            <span className="fs-3">Need Attention</span>
            <div className="fs-6 fw-bold text-white">Event 1 </div>
            <div className="">
              <div className="text-white opacity-75 text-center d-flex justify-content-between my-1">
                <div>Started at</div>
                <div>8.30am</div>
              </div>
              <div className="text-white opacity-75 text-center d-flex justify-content-between my-1">
                <div>Running for</div>
                <div>30 mins</div>
              </div>{" "}
              <div className="text-white opacity-75 text-center d-flex justify-content-between my-1">
                <div> Last Activity at</div> <div>9.30am</div>
              </div>
              <div className=" text-white opacity-75 fw-bold text-center d-flex justify-content-between my-1">
                <div>Requiring Attention</div>
                <div>{data.thisWeek}</div>
              </div>
              <div className=" text-white opacity-75 text-center my-1 d-flex justify-content-between fw-bold">
                <div>Current Live Events</div>
                <div>{data.previousWeek}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
